<template>
	<v-card ref="form" >
    <v-card-text>
      <v-form enctype="multipart/form-data" @submit.prevent="changePassword">
        <!-- Scama name -->
        <v-text-field
          hide-details
          outlined
          v-model="form.oldPassword"
          :label="$t('settings.changePassword.oldPassword')"
          prepend-inner-icon="mdi-lock"
          :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showOldPassword = !showOldPassword"
          :type="showOldPassword ? 'text' : 'password'"
        ></v-text-field>
        <template v-if="errors.oldPassword">
          <span class="errorItem">{{errors.oldPassword[0]}}</span>
          <br>
        </template>
        <br>

        <!-- Button Name -->
        <v-text-field
          outlined
          hide-details
          :label="$t('settings.changePassword.newPassword')"
          v-model="form.newPassword"
          prepend-inner-icon="mdi-lock"
          :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showNewPassword = !showNewPassword"
          :type="showNewPassword ? 'text' : 'password'"
        ></v-text-field>
        <template v-if="errors.newPassword">
          <span class="errorItem">{{errors.newPassword[0]}}</span>
          <br>
        </template>
        <br>
        <v-btn x-large block type="submit" color="primary">
          <v-icon left>mdi-lock-reset</v-icon> Change Password
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.errorItem{
  color:red; 
  float:left
}
</style>

<script>

import User from "@/apis/User";

  export default {
  	name: 'changePassword',
    data(){
    	return {
        showNewPassword: false,
        showOldPassword: false,
    		form: {
          oldPassword:'',
          newPassword: ''
        },
        errors: [],
			}
    },

    methods: {
      changePassword(){
        this.isLoading= true;
        User.changePassword(this.form)
        .then(() => {
          this.errors = [];
          this.$router.push({name : "Dashboard"});
          this.isLoading= false;
        })
        .catch(error => {
          if(error.response.status === 422){
            this.errors = error.response.data.errors;
          }
          this.isLoading= false;
        });
      }
    },
  };
</script>